var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConicalFlask({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#eeeeee",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1570 4975 l0 -145 75 0 75 0 0 -646 0 -646 -521 -1441 c-287 -793 -524 -1450 -526 -1459 -3 -11 74 -130 213 -328 l218 -310 1456 0 1456 0 218 311 c136 194 216 317 213 327 -2 9 -239 666 -526 1459 l-521 1441 0 646 0 646 75 0 75 0 0 145 0 145 -990 0 -990 0 0 -145z m1540 -275 l0 -130 -225 0 -225 0 0 -125 0 -125 225 0 225 0 0 -130 0 -130 -225 0 -225 0 0 -130 0 -130 225 0 225 0 0 -156 0 -157 265 -733 c146 -403 265 -735 265 -738 0 -3 -486 -6 -1080 -6 -594 0 -1080 2 -1080 5 0 3 119 336 265 739 l265 733 0 671 0 672 550 0 550 0 0 -130z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConicalFlask);
export default __webpack_public_path__ + "static/media/conical-flask.8ce06b5078dbed3730c658ec1857172a.svg";
export { ForwardRef as ReactComponent };